var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H11.5L17 6.5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H9.5",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1V7H17",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42 11.6102C7.61501 11.4152 7.84653 11.2605 8.10132 11.155C8.35612 11.0494 8.62921 10.9951 8.905 10.9951C9.18079 10.9951 9.45388 11.0494 9.70868 11.155C9.96347 11.2605 10.195 11.4152 10.39 11.6102C10.585 11.8052 10.7397 12.0368 10.8452 12.2915C10.9508 12.5463 11.0051 12.8194 11.0051 13.0952C11.0051 13.371 10.9508 13.6441 10.8452 13.8989C10.7397 14.1537 10.585 14.3852 10.39 14.5802L4.95 20.0002L1 21.0002L1.99 17.0502L7.42 11.6102Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationForm);
export default __webpack_public_path__ + "static/media/confirmation_form.05a1816ecb403f1be0823de95cda70d8.svg";
export { ForwardRef as ReactComponent };